import { Card, Flex, Typography } from 'antd'
import React from 'react'

interface Props {
    title: string
    icon: any
    onClick: VoidFunction
}

export const ShortCut = (props: Props) => {
    return (
        <Card
            onClick={props.onClick}
            style={{
                cursor: 'pointer',
            }}
        >
            <Flex vertical gap="middle">
                {React.createElement(props.icon, { style: { fontSize: 30 } })}
                <Typography.Text className="m-0 text-capitalize">
                    {props.title}
                </Typography.Text>
            </Flex>
        </Card>
    )
}
